var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedAccounts = function SvgLinkedAccounts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.106 17.223-2.15 2.151a2.28 2.28 0 1 1-3.227-3.226l4.302-4.302a2.281 2.281 0 0 1 3.226 0 .76.76 0 1 0 1.075-1.076 3.802 3.802 0 0 0-5.377 0l-4.302 4.303a3.802 3.802 0 1 0 5.378 5.377l2.15-2.151a.76.76 0 0 0-1.075-1.076Z",
    fill: "#053249"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.678 4.425a3.803 3.803 0 0 0-5.378 0l-2.58 2.58a.76.76 0 0 0 1.075 1.076l2.58-2.58a2.282 2.282 0 0 1 3.227 3.226l-4.732 4.732a2.28 2.28 0 0 1-3.225 0 .76.76 0 0 0-1.076 1.075 3.802 3.802 0 0 0 5.377 0l4.732-4.732a3.802 3.802 0 0 0 0-5.377Z",
    fill: "#053249"
  })));
};
export default SvgLinkedAccounts;